/**
 * @author Mr_FabiozZz[mr.fabiozzz@gmail.com]
 */

import React from "react";
import sass from "./head.module.sass";
import cn from "classnames";

const Legend: React.FC<{ factor: "row" | "column"; stepOne: boolean | null }> = ({ factor, stepOne }) => {
	return (
		<div data-comment-false={true} className={sass.legend}>
			<p className={sass.title}>Легенда:</p>
			{stepOne ? (
				<>
					<div className={sass.item}>
						{factor === "row" ? <div className={cn(sass.big_circle)} /> : <div className={cn(sass.square)} />}
						<p>Ожидает утверждения модели угроз</p>
					</div>
					<div className={sass.item}>
						{factor === "row" ? (
							<div className={cn(sass.big_circle, sass.square_allow)} />
						) : (
							<div className={cn(sass.square, sass.square_allow)} />
						)}
						<p>Модель угроз утверждена</p>
					</div>
					<div className={sass.item}>
						{factor === "row" ? (
							<div className={cn(sass.big_circle, sass.square_success)} />
						) : (
							<div className={cn(sass.square, sass.square_success)} />
						)}
						<p>Объект получил категорию</p>
					</div>
					<div className={sass.item}>
						{factor === "row" ? (
							<div className={cn(sass.big_circle, sass.square_purple)} />
						) : (
							<div className={cn(sass.square, sass.square_purple)} />
						)}
						<p>Повторное категорирование</p>
					</div>
					{/*{!stepOne &&*/}
					{/*    <div className={sass.item}>*/}
					{/*        {factor === 'row' &&*/}
					{/*            <>*/}
					{/*                <div className={cn(sass.big_circle, sass.square_warn)}/>*/}
					{/*                <p>Данные отправлены в ФСТЭК</p>*/}
					{/*                </>*/}
					{/*        }*/}
					{/*    </div>*/}
					{/*}*/}
					{factor === "column" && (
						<>
							<div className={sass.item}>
								<div className={cn(sass.circle, sass.circle_warning)} />
								<p>Заполнено частично</p>
							</div>
							<div className={sass.item}>
								<div className={cn(sass.circle, sass.circle_error)} />
								<p>Не заполнено</p>
							</div>
						</>
					)}
				</>
			) : (
				<>
					<div className={sass.item}>
						{factor === "row" ? (
							<div className={cn(sass.big_circle, sass.square_allow)} />
						) : (
							<div className={cn(sass.square, sass.square_allow)} />
						)}
						<p>Расчет не производился</p>
					</div>
					<div className={sass.item}>
						{factor === "row" ? (
							<div className={cn(sass.big_circle, sass.square_success)} />
						) : (
							<div className={cn(sass.square, sass.square_success)} />
						)}
						<p>Расчет готов</p>
					</div>
					<div className={sass.item}>
						{factor === "row" ? (
							<div className={cn(sass.big_circle, sass.square_purple)} />
						) : (
							<div className={cn(sass.square, sass.square_purple)} />
						)}
						<p>Повторное категорирование</p>
					</div>
					{factor === "column" && (
						<>
							<div className={sass.item}>
								<div className={cn(sass.circle, sass.circle_warning)} />
								<p>Заполнено частично</p>
							</div>
							<div className={sass.item}>
								<div className={cn(sass.circle, sass.circle_error)} />
								<p>Не заполнено</p>
							</div>
						</>
					)}
				</>
			)}
		</div>
	);
};

export default Legend;
